import React, { useEffect, useRef, useState } from "react";
import { HOLCGrade } from "./RedliningMap";

interface PopupProps {
  x: number;
  y: number;
  onButtonClick: (grade: HOLCGrade) => void;
}

const Popup: React.FC<PopupProps> = ({ x, y, onButtonClick }) => {
  const [popupPosition, setPopupPosition] = useState({ x, y });
  const popupRef = useRef<HTMLDivElement>(null);

  // Move the popup if it overflows the parent container
  useEffect(() => {
    const parentContainer = document.getElementById("redlining-map");
    if (parentContainer) {
      const parentRect = parentContainer.getBoundingClientRect();
      const popupRect = popupRef.current!.getBoundingClientRect();

      let newX = x;
      let newY = y;

      // Check if popup overflows on the right side
      if (x + popupRect.width > parentRect.right) {
        newX = parentRect.right - popupRect.width;
      }

      // Check if popup overflows on the left side
      if (x < parentRect.left) {
        newX = parentRect.left;
      }

      // Check if popup overflows on the bottom side
      if (y + popupRect.height > parentRect.bottom) {
        newY = parentRect.bottom - popupRect.height;
      }

      // Check if popup overflows on the top side
      if (y < parentRect.top) {
        newY = parentRect.top;
      }

      setPopupPosition({ x: newX, y: newY });
    }
  }, [x, y]);

  return (
    <div
      style={{
        left: popupPosition.x,
        top: popupPosition.y,
      }}
      className="redlining-popup"
      ref={popupRef}
    >
      <button
        onClick={() => onButtonClick(HOLCGrade.FIRST)}
        className="rdl-popup-btn"
      >
        <div id="rdl-first"></div>
        <span>Best</span>
      </button>
      <button
        onClick={() => onButtonClick(HOLCGrade.SECOND)}
        className="rdl-popup-btn"
      >
        <div id="rdl-second"></div>
        <span>Still Desirable</span>
      </button>
      <button
        onClick={() => onButtonClick(HOLCGrade.THIRD)}
        className="rdl-popup-btn"
      >
        <div id="rdl-third"></div>
        <span>Definitely Declining</span>
      </button>
      <button
        onClick={() => onButtonClick(HOLCGrade.FOURTH)}
        className="rdl-popup-btn"
      >
        <div id="rdl-fourth"></div>
        <span>Hazardous</span>
      </button>
    </div>
  );
};

export default Popup;
